export enum PriceName {
	
	COST_FORD = 'COST_FORD',
	SELLER_PRICE = 'SELLER_PRICE',
	PRICE_CUSTOMER = 'PRICE_CUSTOMER',
	COST_WARRANTY = 'COST_WARRANTY',
	COST_SERVICE = 'COST_SERVICE'


}
export function getPriceNameList(): PriceName[] {
	return Object.values(PriceName) as PriceName[];
}
